import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SmallText, InlineLink } from 'modules/styled';
import { goToTopic } from 'modules/navigation/navigation.actions';

interface TagProps {
  name: string;
  community: string;
  c: string;
  noLink?: boolean;
}

export const Tag = ({ community, name, noLink, c }: TagProps): JSX.Element => {
  const filter = useSelector((state: any) => state.navigation.discover.sort);
  const link = encodeURI(`/${community}/${filter || 'new'}/${name}`);
  const dispatch = useDispatch();
  return (
    <InlineLink
      hu
      to={link}
      c={c}
      webAction={(e: Event) => e.stopPropagation()}
      nativeAction={() => dispatch(goToTopic(name))}
      disabled={noLink}
    >
      <SmallText sx={{ color: c }}>
        {'#'}
        {name}&nbsp;
      </SmallText>
    </InlineLink>
  );
};
